import { Component, OnInit ,Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { AlertComponent } from '../alert/alert.component';
import { DataApiService } from 'src/app/Services/data-api.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';

export interface DialogData2 {
  idUser: string;  
}

@Component({
  selector: 'app-dialog-cambiar-estado-convenio',
  templateUrl: './dialog-cambiar-estado-convenio.component.html',
  styleUrls: ['./dialog-cambiar-estado-convenio.component.scss']
})
export class DialogCambiarEstadoConvenioComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogCambiarEstadoConvenioComponent>,
    private dataApi:DataApiService,
    private http:HttpClient,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData2) {}

  private url =this.dataApi.url;
  
  public error = null;  

  public form={
    id:this.data.idUser,
    estadoConvenio:null
  }  
  
  private mensaje = "El estado ha sido cambiado con éxito";

  ngOnInit() {
    this.mostrarEstadoConvenio();    
  }

  mostrarEstadoConvenio(){
    this.http.get(`${this.url}/mostrarEstado/${this.data.idUser}`).subscribe((data)=>{
      this.form.estadoConvenio= data[0].convenio;    
    });
  }

  cambiarConvenioEstado(){
    
    this.http.post(`${this.url}/actualizarEstadoConvenio`,this.form).subscribe(
      data =>this.handleResponse(data),
      error =>this.handleError(error)
    )
  }
  handleResponse(data){    
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(AlertComponent,{
      width:"200px",
      data:{mensaje:this.mensaje},
      disableClose: false,
      autoFocus:true
    }); 

    dialogRef.afterClosed().subscribe(result => {      
      this.mensaje = result;
    });
  }
  handleError(error){
    this.error = error.error.error;
  }
  
  

}
